import { render, staticRenderFns } from "./ActiveContractsList.vue?vue&type=template&id=f41b703c&"
import script from "./ActiveContractsList.vue?vue&type=script&lang=ts&"
export * from "./ActiveContractsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports